"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpAssigneeRendererFactory = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const OpAssigneeRendererFactory = (viewField) => (item) => {
    const staff = (0, get_1.default)(item, 'staff');
    const teams = (0, get_1.default)(item, 'teams');
    const positions = (0, get_1.default)(item, 'positions');
    let datapills = [];
    staff.map(s => {
        datapills.push(react_1.default.createElement(DataPill_1.default, { value: s.title, type: DataType_1.default.STAFF, avatarUrl: s.profileImageUrl, textWidth: viewField.width - 60 }));
    });
    teams.map(t => {
        datapills.push(react_1.default.createElement(DataPill_1.default, { value: t.title, type: DataType_1.default.TEAM, textWidth: viewField.width - 60 }));
    });
    positions.map(p => {
        datapills.push(react_1.default.createElement(DataPill_1.default, { value: p.title, type: DataType_1.default.POSITION, textWidth: viewField.width - 60 }));
    });
    return react_1.default.createElement(react_1.default.Fragment, null, datapills);
};
exports.OpAssigneeRendererFactory = OpAssigneeRendererFactory;
exports.default = exports.OpAssigneeRendererFactory;
